import React, { useState } from 'react';
import { Check, Copy } from 'lucide-react';

interface TaskIdPillProps {
  taskId: string;
}

export function TaskIdPill({ taskId }: TaskIdPillProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    event.stopPropagation();
    try {
      await navigator.clipboard.writeText(taskId);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1500);
    } catch {
      // Clipboard access can fail in insecure contexts; the pill is purely
      // a convenience so we silently swallow.
    }
  };

  return (
    <button
      type="button"
      onClick={handleCopy}
      title={copied ? 'Copied!' : 'Click to copy task ID'}
      aria-label={copied ? 'Task ID copied to clipboard' : `Copy task ID ${taskId}`}
      className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-gray-100 text-gray-600 hover:bg-gray-200 font-mono"
    >
      {copied ? <Check className="h-3 w-3" /> : <Copy className="h-3 w-3" />}
      <span>{taskId}</span>
    </button>
  );
}
